import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import jwtAxios from '@tenant/services/auth/jwt-auth';
import IntlMessages from '@tenant/utility/IntlMessages';

// Initial state
const initialState = {
  user: {},
  loading: true,
  loadingPermission: false,
  loadedPermission: false,
  error: '',
  permissions: [],
};

// Async thunk for fetching user info
export const getUserInfo = createAsyncThunk(
  'authorization/getUserInfo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get('/api/User/GetUserInfo');
      if (response.status === 200) {
        return response.data;
      } else {
        return rejectWithValue(
          <IntlMessages id='message.somethingWentWrong' />,
        );
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const getUserPermissions = createAsyncThunk(
  'auth/getUserPermissions',
  async (_, { rejectWithValue }) => {
    try {
      const response = await jwtAxios.get(`/api/permissions/me`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// Create slice
const authorizationSlice = createSlice({
  name: 'authorization',
  initialState,
  reducers: {
    // Regular reducers
  },
  extraReducers: (builder) => {
    // getUserInfo reducers
    builder
      .addCase(getUserPermissions.pending, (state) => {
        state.loadingPermission = true;
        state.error = '';
      })
      .addCase(getUserPermissions.fulfilled, (state, action) => {
        state.permissions = action.payload?.Permissions || [];
        state.loadingPermission = false;
        state.loadedPermission = true;
        state.error = '';
      })
      .addCase(getUserPermissions.rejected, (state, action) => {
        state.loadingPermission = false;
        state.error = action.payload;
      })
      .addCase(getUserInfo.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(getUserInfo.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.error = '';
      })
      .addCase(getUserInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export reducer
export default authorizationSlice.reducer;
